var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-mb-5"},[_c('persisted-radio-group',{attrs:{"storage-key":_vm.storageKey,"options":_vm.options,"label":_vm.$options.i18n.label},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }